import React from "react";
import Header from "./components/Header";
import Meteo from "./components/Meteo";

const App = () => {
  return (
    <>
      <Header />
      <Meteo />
    </>
  );
};

export default App;
